import React from 'react';
import ReactDOM from 'react-dom/client';
import '@triplabo/web/styles/index.css';
import '@triplabo/web/i18n';
import '@triplabo/web/vendors/sentry';
import { installAscfGeolocation } from '@triplabo/web/utils/ascfGeolocation';

import App from '@triplabo/web/App';

// ASCF元服务geolocation
installAscfGeolocation();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
